import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, filter, map, of, switchMap } from 'rxjs';

import { GroupsStoreActions } from '@hosty-app/app-store';
import { DashboardService } from '@hosty-app/services';

import * as DashboardActions from '../dashboard.actions';
import * as DashboardSelectors from '../dashboard.selectors';

import * as RevenueActions from './revenue.actions';
import * as RevenueSelectors from './revenue.selectors';
import { revenueInitialState } from './revenue.state';

@Injectable()
export class RevenueStoreEffects {
  getRevenue$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RevenueActions.get),
      concatLatestFrom(() => this.store.select(RevenueSelectors.selectState)),
      filter(([, state]) => state === revenueInitialState),
      map(() => RevenueActions.load()),
    ),
  );

  applyParams$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DashboardActions.applyParams),
      map(() => RevenueActions.load()),
    ),
  );

  loadRevenue$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RevenueActions.load),
      concatLatestFrom(() => [this.store.select(DashboardSelectors.selectParams)]),
      switchMap(([, params]) =>
        this.dashboardService.getRevenueData({ ...params, groupIds: params.groupIds }).pipe(
          map((r) =>
            RevenueActions.loadSuccess({
              payload: { params, data: r },
            }),
          ),
          catchError((err) => of(RevenueActions.loadFailure())),
        ),
      ),
    ),
  );

  clear$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GroupsStoreActions.setCurrentGroup),
      map(() => RevenueActions.clear()),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store,
    private dashboardService: DashboardService,
  ) {}
}
